import { Button, Dialog, NAME_SOUND_ACTIVE, useGameSounds, useTranslate } from "@educaplay/core";
import classes from "./SkipButton.module.scss";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

export default function SkipButton(props) {

    const { children, msg, showButton, onComplete, className } = props;
    const gameSounds = useGameSounds();
    const [openDialog, setOpenDialog] = useState(false);
    const t = useTranslate();

    const passQuestionHandler = () => {
        setOpenDialog(true);
    }

    const closeDialogHandler = () => {
        setOpenDialog(false);
    }

    const acceptDialogHandler = () => {
        closeDialogHandler();
        onComplete();
    }

    return (
        <>
            <Dialog open={openDialog} onClose={closeDialogHandler}>
                <div className={classes.modal} onClick={(e) => { e.stopPropagation() }}>
                    <div className={classes.modalHeader}>
                        <p>{msg}</p>
                    </div>
                    <div className={classes.modalFooter}>
                        <Button className={classes.btnCancel} onClick={closeDialogHandler}>{t("common.settings.cancel")}</Button>
                        <Button className={classes.btnAccept} onClick={acceptDialogHandler}>{t("common.settings.accept")}</Button>
                    </div>
                </div>
            </Dialog>

            <AnimatePresence>
                {showButton && (
                    <motion.button
                        className={clsx(classes.button, className)}
                        onClick={passQuestionHandler}
                        onMouseEnter={() => gameSounds.play(NAME_SOUND_ACTIVE)}
                        initial={{ opacity: 0, y: "100%" }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ y: "150%" }}
                        transition={{ duration: .3, type: "spring", delay: .2 }}
                    >
                        {children}
                    </motion.button>)}
            </AnimatePresence>

        </>
    )
}   